// A season-stat value or abbr as display text. The API usually stringifies
// stats but sometimes sends a raw number (or null), so never call string
// methods on the field directly.
export const toStatText = (value: string | number | null | undefined): string =>
  value == null ? '' : String(value).trim()
